import app, { Component } from 'apprun';
import { addresses, serializeObject } from '../api';
import { isValid, showSaveStatusMessage } from '../utils';
import { lookup_en } from '../utils';

export default class CommonPropertyAddressComponent extends Component {
  state = {};
  view = (state) => {
    //console.log(state);
    return (
      <div>
        <form id="addressEditForm" class="form-horizontal" style={{ width: '450px' }}>
          <table>
            <tr>
              <td>
                <label class="control-label">Street Number</label>&nbsp;
              </td>
              <td>
                <label class="control-label">Street Number Suffix</label>&nbsp;
              </td>

            </tr>

            <tr>
              <td style={{ padding: '5px 0px' }}>
                <input
                  size="7"
                  id="streetNumber"
                  name="streetNumber"
                  value={state.address ? state.address.streetNumber : ''}
                  data-validate
                />
                <div id="streetNumberErrMsg" class="text-danger"></div>
              </td>
              <td style={{ padding: '5px 0px' }}>
                <input
                  size="2"
                  id="streetNumberSuffix"
                  name="streetNumberSuffix"
                  value={state.address ? state.address.streetNumberSuffix : ''}
                />
              </td>

            </tr>

            <tr>
              <td>
                <label class="control-label">Street Name</label>&nbsp;
              </td>
              <td>
                <label class="control-label">Street Type</label>&nbsp;
              </td>
              <td>
                <label class="control-label">Street Dir.</label>&nbsp;
              </td>
            </tr>

            <tr>
              <td style={{ padding: '5px 0px' }}>
                <input
                  size="15"
                  id="streetName"
                  name="streetName"
                  value={state.address ? state.address.streetName : ''}
                  data-validate
                />
                <div id="streetNameErrMsg" class="text-danger"></div>
              </td>
              <td style={{ padding: '5px 0px' }}>
                <select id="StreetTypeCt" name="StreetTypeCt">
                  {lookup_en.StreetTypeCt.map((r) => {
                    return (
                      <option
                        value={r.id}
                        selected={state.address ? (r.id === state.address.streetTypeCt ? 'selected' : null) : null}>
                        {r.value}
                      </option>
                    );
                  })}
                </select>
                &nbsp;
                <div id="StreetTypeCtErrMsg" class="text-danger"></div>
              </td>
              <td>
                <select id="StreetDirectionCt" name="StreetDirectionCt">
                  {lookup_en.StreetDirectionCt.map((r) => {
                    return (
                      <option
                        value={r.id}
                        selected={state.address ? (r.id === state.address.streetDirectionCt ? 'selected' : null) : null}>
                        {r.value}
                      </option>
                    );
                  })}
                </select>
                <div id="StreetDirectionCtErrMsg" class="text-danger"></div>
              </td>
            </tr>

            <tr>
              <td>
                <label class="control-label">Unit Number</label>
              </td>
              <td>
                <input name="unitNumber" size="7" value={state.address ? state.address.unitNumber : ''} />
                <br />
              </td>
            </tr>
            <tr>
              <br />
            </tr>
            <tr>
              <td>
                <label class="control-label">City</label>
              </td>
              <td>
                <input
                  id="city"
                  name="city"
                  class="pull-right"
                  value={state.address ? state.address.city : ''}
                  data-validate
                />
              </td>
            </tr>
            <tr>
              <td />
              <td>
                <div id="cityErrMsg" class="text-danger"></div>
              </td>
            </tr>
            <tr>
              <td>
                <label class="control-label">Province</label>
              </td>
              <td>
                <select id="provStateCt" name="provStateCt" required="required" data-validate="Int-1">
                  {lookup_en.ProvStateCt.map((r) => {
                    return (
                      <option
                        value={r.id}
                        selected={state.address ? (r.id === state.address.provStateCt ? 'selected' : null) : null}>
                        {r.value}
                      </option>
                    );
                  })}
                </select>
              </td>
            </tr>
            <tr>
              <td />
              <td>
                <div id="provStateCtErrMsg" class="text-danger"></div>
              </td>
            </tr>
            <tr>
              <td>
                <label class="control-label">PostalCode</label>
              </td>
              <td>
                <input
                  id="postalCode"
                  name="postalCode"
                  class="pull-right"
                  value={state.address ? state.address.postalCode : ''}
                  data-validate="PCode"
                />
              </td>
            </tr>
            <tr>
              <td />
              <td>
                <div id="postalCodeErrMsg" class="text-danger"></div>
              </td>
            </tr>
          </table>
        </form>
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('save', e)}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state = newState;
      const address = await addresses.getAddress(newState.objectTypeId, newState.addressId);
      return { ...state, address };
    },

    save: async (state) => {
      if (!isValid('addressEditForm')) {return;}
      try{
        const formData = serializeObject(document.getElementById('addressEditForm'));
        const result = await addresses.postAddress(state.objectTypeId, state.addressId, formData);
        showSaveStatusMessage('address');
        if (result) {state.caller.run(state.save, state.item, state.panelId);}
      }catch{showSaveStatusMessage();}
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
